var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.error)?_c('Error'):_vm._e(),(this.$route.name=='Home' && !_vm.error && !_vm.cargando)?_c('Header'):_vm._e(),(!_vm.error && !_vm.cargando)?_c('v-main',[_c('router-view')],1):_vm._e(),(this.$route.name=='Home' && !_vm.error && !_vm.cargando)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }